import axiosInstance from './axios';

export const authorizedRequest = async (config: any) => {
  const token = localStorage.getItem('token');
  const headers = {
    ...(config.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  return await axiosInstance({ ...config, headers });
};
